import React, { useEffect, useRef } from 'react';
import Glide from '@glidejs/glide';
import { sliderPropTypes } from './SliderPropTypes';
import '@glidejs/glide/dist/css/glide.core.min.css';
const Slider = _ref => {
  let {
    slides,
    config,
    classname
  } = _ref;
  const sliderRef = useRef(null);
  useEffect(() => {
    const glide = new Glide(sliderRef.current, config);
    glide.mount();
    return () => glide.destroy();
  }, [config]);
  return /*#__PURE__*/React.createElement("div", {
    className: classname || ''
  }, /*#__PURE__*/React.createElement("div", {
    className: "glide",
    ref: sliderRef
  }, /*#__PURE__*/React.createElement("div", {
    className: "glide__track",
    "data-glide-el": "track"
  }, /*#__PURE__*/React.createElement("ul", {
    className: "glide__slides"
  }, slides.map((slide, index) => /*#__PURE__*/React.createElement("li", {
    key: index,
    className: "glide__slide"
  }, slide)))), /*#__PURE__*/React.createElement("div", {
    className: "glide__bullets",
    "data-glide-el": "controls[nav]"
  }, slides.map((_, index) => /*#__PURE__*/React.createElement("button", {
    key: index,
    className: "glide__bullet",
    "data-glide-dir": `=${index}`
  })))));
};
export default Slider;